export default __webpack_public_path__ + "locales/sk/Payments.json?hash=242a26ebd59cb0ffdf3ca36eb262f233";